export default "__VITE_ASSET__CMAk607J__"